export default __webpack_public_path__ + "static/visual-app-builder-1-303c90ae07c2f2b88da171937f11691e.png";